import { useContext } from 'react';
import { SystemMessageContext } from '../components/contexts/SystemMessageContext';

export function useSystemMessage() {
  const { success, danger, info, warn } = useContext(SystemMessageContext);
  return { success, danger, info, warn };
}
